<div
  #feedbackContainer
  class="feedback"
  [class.open]="showFeedback()"
  [class.success]="isCorrectFeedback"
  [class.warning]="isIncorrectFeedback"
  [class.selfCheck]="isSelfCheckFeedback"
  [class.informational]="isInformationalFeedback"
>
  @if (feedback()?.type !== feedbackType.SELF_CHECK) {
    @if (feedback()?.type === feedbackType.CORRECT) {
      <h2>Goed</h2>
    }
    @if (feedback()?.type === feedbackType.INCORRECT) {
      <h2>Helaas</h2>
    }
    <ng-container *ngTemplateOutlet="feedbackValue" />
    <ng-container *ngTemplateOutlet="toggleExtendedFeedbackButton" />
  } @else {
    <div class="header-bar">
      <h2>Controleer jouw antwoord</h2>
      <ion-button
        size="small"
        class="btn-info"
        (click)="openSelfCheckHelpModal()"
      >
        <ion-icon name="information-circle-outline" slot="icon-only" />
      </ion-button>
    </div>
    <ng-container *ngTemplateOutlet="feedbackValue" />
    <ng-container *ngTemplateOutlet="toggleExtendedFeedbackButton" />
    <ion-checkbox
      class="self-check-checkbox"
      [formControl]="givenAnswerWasCorrectFormControl"
      labelPlacement="end"
      justify="start"
      mode="md"
    >
      Ik heb deze vraag goed beantwoord.
    </ion-checkbox>
  }

  @if (platform.is('ios') === false) {
    <div
      class="toggle-button-container-mobile"
      title="in-/uitklappen (alt + u)"
    >
      <ion-button class="toggle-button-mobile" (click)="toggleFeedbackView()">
        <ion-icon name="chevron-up-outline" slot="icon-only" />
      </ion-button>
    </div>
  }

  <div class="next-question">
    <ion-button (click)="nextQuestion()" [disabled]="disabled()">
      {{
        step()?.thankYouType === ThankYouType.RETURN &&
        step()?.position === step()?.totalQuestions
          ? 'Afronden'
          : 'Volgende vraag'
      }}
      <ion-icon slot="end" name="arrow-forward" />
    </ion-button>
  </div>

  @if (!disabled()) {
    <div class="hotkey ion-hide-md-down">
      Gebruik <span>Shift &#8657; + Enter &#8629;</span>
    </div>
  }
</div>
<ng-template #feedbackValue>
  @if (showFeedback()) {
    <div
      class="feedback-value"
      [innerHTML]="
        (extendedFeedbackToggleEnabled || !feedback()?.compact
          ? feedback()?.extended
          : feedback()?.compact)!
          | displayTable
          | displayMath
      "
      feedbackPlaceholder
    ></div>
  }
</ng-template>

<ng-template #toggleExtendedFeedbackButton>
  @if (showFeedback() && feedback()?.compact && feedback()?.extended) {
    <div
      (click)="toggleExtendedFeedback()"
      class="toggle-feedback ion-activatable ripple-parent"
    >
      {{
        extendedFeedbackToggleEnabled
          ? 'Lees korte uitleg'
          : 'Lees uitgebreide uitleg'
      }}
      <ion-ripple-effect />
    </div>
  }
</ng-template>
